/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Starter_Pack_Pop_Up_BtnInputs */

const en_starter_pack_pop_up_btn = /** @type {(inputs: Starter_Pack_Pop_Up_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View offer`)
};

const ar_starter_pack_pop_up_btn = /** @type {(inputs: Starter_Pack_Pop_Up_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const de_starter_pack_pop_up_btn = /** @type {(inputs: Starter_Pack_Pop_Up_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const es_starter_pack_pop_up_btn = /** @type {(inputs: Starter_Pack_Pop_Up_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const fr_starter_pack_pop_up_btn = /** @type {(inputs: Starter_Pack_Pop_Up_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const it_starter_pack_pop_up_btn = /** @type {(inputs: Starter_Pack_Pop_Up_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const ja_starter_pack_pop_up_btn = /** @type {(inputs: Starter_Pack_Pop_Up_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const ko_starter_pack_pop_up_btn = /** @type {(inputs: Starter_Pack_Pop_Up_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const pt_br_starter_pack_pop_up_btn = /** @type {(inputs: Starter_Pack_Pop_Up_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const ru_starter_pack_pop_up_btn = /** @type {(inputs: Starter_Pack_Pop_Up_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const th_starter_pack_pop_up_btn = /** @type {(inputs: Starter_Pack_Pop_Up_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const tr_starter_pack_pop_up_btn = /** @type {(inputs: Starter_Pack_Pop_Up_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const zh_cn_starter_pack_pop_up_btn = /** @type {(inputs: Starter_Pack_Pop_Up_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const zh_tw_starter_pack_pop_up_btn = /** @type {(inputs: Starter_Pack_Pop_Up_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

/**
* | output |
* | --- |
* | "View offer" |
*
* @param {Starter_Pack_Pop_Up_BtnInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const starter_pack_pop_up_btn = /** @type {((inputs?: Starter_Pack_Pop_Up_BtnInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Starter_Pack_Pop_Up_BtnInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_starter_pack_pop_up_btn(inputs)
	if (locale === "ar") return ar_starter_pack_pop_up_btn(inputs)
	if (locale === "de") return de_starter_pack_pop_up_btn(inputs)
	if (locale === "es") return es_starter_pack_pop_up_btn(inputs)
	if (locale === "fr") return fr_starter_pack_pop_up_btn(inputs)
	if (locale === "it") return it_starter_pack_pop_up_btn(inputs)
	if (locale === "ja") return ja_starter_pack_pop_up_btn(inputs)
	if (locale === "ko") return ko_starter_pack_pop_up_btn(inputs)
	if (locale === "pt_br") return pt_br_starter_pack_pop_up_btn(inputs)
	if (locale === "ru") return ru_starter_pack_pop_up_btn(inputs)
	if (locale === "th") return th_starter_pack_pop_up_btn(inputs)
	if (locale === "tr") return tr_starter_pack_pop_up_btn(inputs)
	if (locale === "zh_cn") return zh_cn_starter_pack_pop_up_btn(inputs)
	return zh_tw_starter_pack_pop_up_btn(inputs)
});